import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76c1d2a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = { class: "d-flex gap-3 text-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_4 = ["data-kt-indicator", "onClick"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, "Submit", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode("Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "text-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormField = _resolveComponent("FormField")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "form w-100 fv-plugins-bootstrap5 fv-plugins-framework",
    ref: "forgotPasswordForm",
    "validation-schema": _ctx.formSchema
  }, {
    default: _withCtx(({ handleSubmit, validate, values }) => [
      _createElementVNode("form", {
        onSubmit: _withModifiers(($event: any) => (handleSubmit(_ctx.submitForgotPasswordForm)), ["prevent"])
      }, [
        _createVNode(_component_FormField, {
          required: true,
          name: "email",
          value: values.email,
          formControlClass: "form-control form-control-lg text-login",
          showLabel: false,
          placeholder: "Email",
          type: "email"
        }, null, 8, ["value"]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_router_link, {
            to: "/sign-in",
            class: "btn btn-new-design-secondary w-50 mb-5"
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createElementVNode("button", {
            type: "submit",
            id: "kt_sign_in_submit",
            class: "btn w-50 mb-5 btn-new-design-primary",
            "data-kt-indicator": _ctx.loading ? 'on' : null,
            onClick: validate
          }, _hoisted_7, 8, _hoisted_4),
          (_ctx.recaptcha_error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " ReCaptcha is having an error. Please refresh page and try again. "))
            : _createCommentVNode("", true)
        ])
      ], 40, _hoisted_1)
    ]),
    _: 1
  }, 8, ["validation-schema"]))
}